import { useQuery } from '@tanstack/react-query';

export type Family = {
  id: string;
  name: string;
  advisorUserId: string;
  mainFamilyMember: { clientId: string };
  secondaryFamilyMembers: {
    clientId: string;
    relationshipToMainFamilyMember: Relation;
  }[];
  members: { clientId: string; familyRoleId: string | null }[];
  relationships: {
    fromClientId: string;
    toClientId: string;
    relationshipType: Relation;
  }[];
  createdAt: string;
};

export type Relation = 'Spouse' | 'Partner' | 'Child' | 'Parent' | 'Sibling' | 'Other';

export const useFamily = (familyId?: string) => {
  const { data, isLoading, error } = useQuery<Family>({
    queryKey: ['families', familyId],
    enabled: !!familyId,
  });

  return {
    family: data ?? null,
    isLoading,
    error,
  };
};
